import classNames from 'classnames';

import Diamond from 'components/icons/Diamond';
import { TEMPO_PREMIUM, WHITE_100 } from 'lib/constants/index';

const MealPrimaryLabel = ({
  aLaCarte = false,
  textColor = WHITE_100,
  containerStyle,
  hexColor,
  primaryLabel,
}) => {
  const isTempoPremium = primaryLabel === TEMPO_PREMIUM;

  if (aLaCarte && primaryLabel.length > 15) return null;

  const primaryLabelText = () => {
    if (isTempoPremium) {
      return 'Premium'.toUpperCase();
    } else {
      return primaryLabel.toUpperCase();
    }
  };

  const tempoDiamond = () => {
    return (
      <span className="mr-1 flex">
        <Diamond />
      </span>
    );
  };

  return (
    <div
      className={classNames(
        'h7 inline-flex items-center overflow-hidden whitespace-nowrap rounded px-2 leading-relaxed tracking-half-px bp1:whitespace-normal',
        containerStyle
      )}
      style={{ backgroundColor: hexColor, color: textColor }}
    >
      {isTempoPremium && tempoDiamond()} {primaryLabelText()}
    </div>
  );
};

MealPrimaryLabel.propTypes = {
  containerStyle: PropTypes.string,
  primaryLabel: PropTypes.string.isRequired,
  hexColor: PropTypes.string,
  textColor: PropTypes.string,
};

export default MealPrimaryLabel;
